<template>
  <div>
    <ProgressBar
      mode="indeterminate"
      style="height:3px;width:100%"
      v-if="loading"
    />
    <div class="p-grid" v-if="getUserData.tipo_usuario==='admin' || getUserData.tipo_usuario==='superadmin' && $route.name==='blog'">
      <div class="p-col-12 p-pl-5">
        <div class="boton-enlace" @click="$router.push({name:'mis_articulos'})">
          <a>Ver mis artículos del blog</a>
        </div>
      </div>
    </div>
    <div class="container-cards p-pt-6">
      <articulo-card
        style="margin-bottom:20px"
        v-for="(articulo, index) in articulos"
        :key="index"
        :titulo="articulo.titulo"
        :ultimaActualizacion="articulo.fecha_publicacion"
        :resumen="articulo.resumen"
        :id="articulo.id"
        :imagenBase="articulo.imagen"
      />
    </div>    
  </div>
</template>
<script>
import articulo_card from "./articulo_card.vue";
import ArticulosService from "../service/articulos.service";
import { mapGetters } from "vuex";
export default {
  metaInfo: {
    title: 'Blog - QualityCare',
    htmlAttrs: {
      lang: 'es',
    },
    meta: [
      {
        name: 'Blog - QualityCare',
        content: 'Se muestra los artículos del blog, para que los usuarios puedan leerlos, y los administradores puedan gestionarlos'
      },
    ],
  },
  name: "blog",
  components: { "articulo-card": articulo_card },
  data() {
    return {
      articulosService: null,
      articulos: [],
      loading: false,
    };
  },
  created() {
    this.articulosService = new ArticulosService();
  },
  mounted() {
    this.loading = true;
    this.articulosService
      .allArticulosForPublic()
      .then((result) => {
        if (result.data.data) {
          this.articulos = [...result.data.data];
        }
        this.loading = false;
      })
      .catch((err) => {
        console.error(err);
        this.$toast.add({
          severity: "error",
          summary: "Error",
          detail: "Error al cargar los artículos",
          life: 3000,
        });
        this.loading = false;
      });
  },
  computed: {
    ...mapGetters(['getUserData']),
  },
};
</script>

<style lang="scss" scoped>
.container-cards{
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
.boton-enlace {
  text-align: center;
  background-color: #083078;
  padding: 10px 0px;
  color: white;
  user-select: none;
  width: fit-content;
  height: fit-content;
  border-radius: 3px;
  margin-top: 40px;
  transition: 0.5s all;
  cursor: pointer;
  a {
    color: white;
    font-size: 16px;
    width: 100%;
    padding: 10px 20px;
  }
}
.boton-enlace:hover {
  background-color: #2b86d9;
}
</style>
